import React, { useState, useEffect } from "react"
import { Box, Typography, Grid } from "@mui/material"
import { useDispatch } from "react-redux"
import CommonModal from "components/CommonModal"
import AppTextField from "components/StyledComponents/AppTextField"
import AppButton from "components/StyledComponents/AppButton"
import { setRewardSpreeQuantityAction } from "redux/superAdmin/actions"

const SpreeQuantityModal = ({ open, onClose, reward, restaurantId, search }) => {
  const dispatch = useDispatch()
  const [value, setValue] = useState("")
  const [error, setError] = useState("")

  useEffect(() => {
    if (open) {
      const current = reward?.spree_total_quantity
      setValue(current === null || current === undefined ? "" : String(current))
      setError("")
    }
  }, [open, reward])

  const handleSave = () => {
    const parsed = parseInt(value, 10)
    if (value === "" || Number.isNaN(parsed) || parsed < 0) {
      setError("Enter a quantity of 0 or more")
      return
    }
    dispatch(
      setRewardSpreeQuantityAction({
        rewardId: reward?.id,
        totalQuantity: parsed,
        restaurantId,
        search,
        callback: onClose
      })
    )
  }

  return (
    <CommonModal
      open={open}
      onClose={onClose}
      maxWidth="xs"
      actionButtons={
        <Box className="d-flex align-items-center justify-content-center gap-2 pb-2">
          <AppButton onClick={handleSave} sx={{ width: "120px" }}>
            Save
          </AppButton>
        </Box>
      }>
      <Box sx={{ mb: 3, textAlign: "center" }}>
        <Typography variant="h6" fontWeight={600}>
          Set Spree Quantity
        </Typography>
        <Typography variant="body2Regular" color="text.secondary">
          {reward?.name}
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="body2Regular" color="text.secondary">
            Redeemed this spree
          </Typography>
          <Typography variant="body1Regular">{reward?.spree_redeemed || 0}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2Regular" color="text.secondary">
            Available now
          </Typography>
          <Typography variant="body1Regular">
            {Math.max(0, (reward?.spree_total_quantity || 0) - (reward?.spree_redeemed || 0))}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <AppTextField
            id="total_quantity"
            name="total_quantity"
            label="Total Quantity (this spree)"
            type="number"
            isUpperCase={true}
            fullWidth
            value={value}
            onChange={(e) => setValue(e.target.value)}
            error={Boolean(error)}
            helperText={error}
          />
        </Grid>
      </Grid>
    </CommonModal>
  )
}

export default SpreeQuantityModal
